import { useMemo } from "react";
import { useTable, usePagination, Column } from "react-table";

interface TableData {
  [key: string]: any;
}

interface TableProps {
  DATA: TableData[];
  COLUMNS: Column<TableData>[];
}

function RoundedTable({ DATA, COLUMNS }: TableProps) {
  const columns = useMemo(() => COLUMNS, [COLUMNS]);
  const data = useMemo(() => DATA, [DATA]);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,

    prepareRow,
    // @ts-ignore
    page, // For pagination
    // @ts-ignore
    canPreviousPage,
    // @ts-ignore
    canNextPage,
    // @ts-ignore
    pageOptions,
    // @ts-ignore
    gotoPage,
    // @ts-ignore
    nextPage,
    // @ts-ignore
    previousPage,
    // @ts-ignore
    setPageSize,
    // @ts-ignore
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns,
      data,
      // @ts-ignore
      initialState: { pageIndex: 0, pageSize: 5 }, // Start from page 0
    },
    usePagination
  );

  return (
    <div className="w-full border border-borderColor rounded-xl overflow-hidden">
      {/* Table */}
      <table
        {...getTableProps()}
        className="w-full table-auto border-collapse text-right"
      >
        <thead className="bg-lightGold">
          {headerGroups.map((headerGroup: any) => (
            <tr
              {...headerGroup.getHeaderGroupProps()}
              className="border-b border-[#E5E7EB]"
            >
              {headerGroup.headers.map((column: any) => (
                <th
                  {...column.getHeaderProps()}
                  className="whitespace-nowrap py-3 pl-6 pr-3 text-left text-sm font-semibold text-[#2A2E34]"
                >
                  {column.render("Header")}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {page.map((row: any, rowIndex: number) => {
            prepareRow(row);
            const isLastRow = rowIndex === page.length - 1;
            return (
              <tr
                {...row.getRowProps()}
                className={`${
                  !isLastRow ? "border-b border-[#E5E7EB]" : ""
                } text-left`}
              >
                {row.cells.map((cell: any) => (
                  <td
                    {...cell.getCellProps()}
                    className="py-3 pl-6 pr-3 text-sm text-gray-700"
                  >
                    {cell.render("Cell")}
                  </td>
                ))}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

export default RoundedTable;
